import { create } from 'zustand';
import { api } from '../services/api';

export const useFeedbackStore = create((set, get) => ({
  feedbacks: [],
  total: 0,
  limit: 50,
  offset: 0,
  isLoading: false,
  error: null,
  status: 'all', // all, read, unread

  // Загрузка отзывов
  fetchFeedback: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const queryParams = {
        limit: params.limit || get().limit,
        offset: params.offset || 0,
        status: params.status || get().status,
      };
      
      const data = await api.getFeedback(queryParams);
      set({
        feedbacks: data.feedbacks,
        total: data.total,
        limit: data.limit,
        offset: data.offset,
        status: params.status || get().status,
        isLoading: false,
      });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Отметить как прочитанный
  markAsRead: async (id) => {
    try {
      await api.markFeedbackAsRead(id);
      // Обновляем список
      get().fetchFeedback({ status: get().status });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Удалить отзыв
  deleteFeedback: async (id) => {
    try {
      await api.deleteFeedback(id);
      get().fetchFeedback({ status: get().status });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Очистка
  clear: () => {
    set({ feedbacks: [], total: 0, error: null });
  },

  // Сброс ошибки
  clearError: () => {
    set({ error: null });
  },
}));
